import { all, put } from "redux-saga/effects";

import {
  fetchActivePayments,
  fetchHistory,
  fetchSchools,
  fetchShopItems,
  fetchStudents,
  fetchParents
} from "state/school_money/actions";

/**
 * Fire all our fetch APIs at once
 */
export default function* fetchAllSaga(action) {

  const forceSchoolFetch = action.payload.forceSchoolFetch;
  const forceStudentFetch = action.payload.forceStudentFetch;
  const forceParentFetch = action.payload.forceParentFetch;
  const forceActivePaymentFetch = action.payload.forceActivePaymentFetch;
  const forceShopFetch = action.payload.forceShopFetch;
  const forceHistoryFetch = action.payload.forceHistoryFetch;

  let fetchActions = [
    fetchActivePayments(forceActivePaymentFetch),
    fetchSchools(forceSchoolFetch),
    fetchShopItems(forceShopFetch),
    fetchStudents(forceStudentFetch),
    fetchParents(forceParentFetch)
  ];

  // History is heaviest data so fetch only if there is a request
  if(forceHistoryFetch) {
    fetchActions.push(fetchHistory(forceHistoryFetch));
  }

  yield all(fetchActions.map(action => put(action)));

}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/fetchAllSaga.js